import { render } from "./AttackRoomGuardianGhostModal.vue?vue&type=template&id=dd2db2ec&scoped=true"
import script from "./AttackRoomGuardianGhostModal.vue?vue&type=script&lang=js"
export * from "./AttackRoomGuardianGhostModal.vue?vue&type=script&lang=js"

import "./AttackRoomGuardianGhostModal.vue?vue&type=style&index=0&id=dd2db2ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2db2ec"]])

export default __exports__